import { extractData } from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  HomePageDtoSchema,
  type HomePageType,
} from "@/_pages/home/model/schemas";

export const mapDtoToHomePage = (dto: unknown): HomePageType => {
  const parsed = safeParseWithFallback(
    HomePageDtoSchema,
    dto,
    "mapDtoToHomePage",
  );

  return extractData(parsed, dto, dto as HomePageType);
};
